/**
 * Returns the browser's current timezone using the Intl API.
 * Optionally saves it to localStorage for reuse within the session.
 *
 * @param saveToStorage - If true, saves the detected timezone to localStorage.
 * @returns A valid IANA timezone string (e.g. "Europe/Kyiv"), or "UTC" as fallback.
 */
export const getBrowserTimezone = (saveToStorage: boolean = false): string => {
  try {
    // Detect timezone via Intl API
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const stored = localStorage.getItem('timezone');

    if (timezone === 'Europe/Kiev') {
      timezone = 'Europe/Kyiv';
    }

    // Optionally persist the timezone in localStorage
    if (saveToStorage) {
      const offsetMinutes = -new Date().getTimezoneOffset();
      localStorage.setItem('timezone', timezone);
      localStorage.setItem('timezoneOffset', offsetMinutes.toString());
    }

    if (timezone === stored) {
       timezone = stored;
    }

    return timezone;
  } catch (error) {
    // Graceful fallback in case of unexpected errors
    console.error('[getBrowserTimezone] Failed to detect browser timezone:', error);
    return 'UTC';
  }
};
